<template>
<ValidationObserver ref="observer">
  <form ref="edit_business_unit_form" @submit.prevent="handleSubmit(updateParkingLine)">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Client Master
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Service Master Code</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="category" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Category</label>
                <md-select v-model="parking_line.parking_line_category" required>
                  <md-option value="1">A</md-option>
                  <md-option value="2">B</md-option>
                  <md-option value="3">C</md-option>
                </md-select>
                <validation-error :errors="apiValidationErrors.parking_line_category" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Service Master Code</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="name" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Name</label>
                <md-input v-model="parking_line.parking_line_name" required />
                <validation-error :errors="apiValidationErrors.parking_line_name" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
      </md-card-content>
      

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

extend('name', {
  ...required,
  message: 'Parking Line Name field is required'
});
extend('category', {
  ...required,
  message: 'Parking Line Category field is required'
});

  Vue.use(VueSweetalert2);
  export default {
    name: "edit-business-unit--test",
    
    

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

   data: () => ({
      parking_line: [],
    }),

    created() {
      this.getParkingLineData();
    },


    methods: {
      
      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Parking Line' })
    },

      // fungsi untuk mendapatkan data yang akan di edit dengan id yang dikirim bersamaan dengan route
      async getParkingLineData(){
        //check apakah id ada di route
        if(this.$route.params.id){
          
        //jika ada ambil data dari api
        await this.$store.dispatch("workshop_parking_line/get", this.$route.params.id)
        this.parking_line = await this.$store.getters["workshop_parking_line/parking_line"]
        }
        else{
          //jika tidak ada kembali ke list
          await this.$router.replace({name: 'List Parking Line'});
        }
      },

      // validasi menggunakan sweetalert  sebelum mengubah data
      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateParkingLine(id)
          }
        });
    },


    // fungsi edit
      async updateParkingLine() {

        // if(this.$route.params.id == null || !this.$route.params.id) {
        //   await this.$store.dispatch("alerts/error", "error")
        //   return
        // }

        const data = {
          type: "workshop_parking_lines",
          id: this.parking_line.id,
          parking_line_category: this.parking_line.parking_line_category,
          parking_line_name: this.parking_line.parking_line_name
        }

        try {
          //kirim data ke server
          await this.$store.dispatch("workshop_parking_line/update", data)
          //panggil alert notifikasi sukses
          await this.$store.dispatch("alerts/success", "Parking Line data changed successfully.")
          //kembali ke list
          await this.$router.replace({name: 'List Parking Line'});
        } catch (e) {
          //panggil notifikasi error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }

      }
    }
  };
</script>
